import { createContext, useContext } from 'react';

export const ModalContext = createContext(false);

export const useIsInModal = () => useContext(ModalContext);
